import { useState } from 'react';
import { capitalizeString } from '../shared/util';
import { load } from '../controllers/capacities';
import { CommonCapacities, Query, Result } from '../interfaces';
import { useSelector } from 'react-redux';

const mapCapacities = (data: any[]) => {
    const items: CommonCapacities[] = [];
    data.map((e: any) => {
        const item: CommonCapacities = {
            id: e.id,
            name: capitalizeString(e.name),
            typology: capitalizeString(e.typology),
            group: capitalizeString(e.group),
            description: capitalizeString(e.description),
            type: capitalizeString(e.type),
            recognized_min: e.recognized_min,
            collection_name: e.collection_name,
            recommended: e.recommended,
            contact_name: e.contact_name,
            contact_email: e.contact_email
        }
        items.push(item);
    });

    return items;
}

const initialState: Result<CommonCapacities> = {
    loading: false,
    values: [],
};

export const useSearchCapacities = ()=>{
    const [result, setResult] = useState<Result<CommonCapacities>>(initialState);
    const userState = useSelector((state: any) => state.user.user);

    const searchCapacities = async (collection: string, query: Query, page?: number, limit?: number) => {
        try {
            setResult((prevResult) => ({ ...prevResult, loading: true }));
            const response = await load(collection || 'all', query, page, limit, userState?.me);
            return setResult({
                values: mapCapacities(response.items),
                loading: false,
                pagination: {
                    limit,
                    page,
                    total: response.meta.total
                }
            });
        } catch (error) {
            console.error("Error fetching data:", error);
            setResult((prevResult) => ({ ...prevResult, loading: false }));
        }
    }

    return {
        result,
        searchCapacities
    }
}
